import { Component } from '@angular/core';
import { SpinnerDialog } from '@ionic-native/spinner-dialog';
import { NavController } from 'ionic-angular';
import { LoginPage } from '../../login/login';


@Component({
    selector: 'page-register-thank-you',
    templateUrl: 'thank-you.html',
})
export class RegisterThankYouPage {


    constructor(
        private navCtrl: NavController,
        private spinner: SpinnerDialog,
    ) {
    }

    async exitApp() {
        this.spinner.show();
        this.navCtrl.setRoot(LoginPage, {}, {animate: true, direction: 'back'});
        this.spinner.hide();
    }

}



// WEBPACK FOOTER //
// ./src/pages/auth/register/thank-you/thank-you.ts